

















import Vue from 'vue'
import { Component, Lifecycle, Prop, p } from 'av-ts'

/**
 * Based on https://github.com/yariksav/vuetify-confirm
 */
@Component()
export default class ConfirmDialog extends Vue {
  @Prop buttonTrueText = p({ type: String, default: 'Yes' })
  @Prop buttonFalseText = p({ type: String, default: 'No' })
  @Prop buttonTrueColor = p({ type: String, default: 'primary' })
  @Prop buttonFalseColor = p({ type: String, default: 'grey' })
  @Prop color = p({ type: String, default: 'warning' })
  @Prop icon = p({ type: String, default: 'warning' })
  @Prop message = p({ type: String, required: false, default: 'Confirm ?' })
  @Prop title = p({ type: String })
  @Prop width = p({ type: Number, default: 300 })

  value = false

  choose(value: boolean) {
    this.$emit('result', value)
    this.value = value
    this.$destroy()    
  }

  change(res: any) {
    this.$destroy()
  }
}


